module.exports = __webpack_public_path__ + "media/images/boxes/srt-box143-48c4b208f810a4fb5211883832644b16.png";